/**
 *
 * @param {*} e
 */
function pageToPoint(e) {
  return {
    x: e.pageX,
    y: e.pageY
  };
}
/**
 *
 * @param {*} lhs
 * @param {*} rhs
 */
function subtract(lhs, rhs) {
  return {
    x: lhs.x - rhs.x,
    y: lhs.y - rhs.y
  };
}

/**
 *
 * @param {*} point
 */
function copy(point) {
  return {
    x: point.x,
    y: point.y
  };
}

/**
 *
 * @param {*} from
 * @param {*} to
 */
function distance(from, to) {
  return Math.sqrt(distanceSquared(from, to));
}

/**
 *
 * @param {*} from
 * @param {*} to
 */
function distanceSquared(from, to) {
  const delta = subtract(from, to);

  return delta.x * delta.x + delta.y * delta.y;
}

/**
 *
 * @param {*} point
 * @param {*} rect
 */
function insideRect(point, rect) {
  if (
    point.x < rect.left ||
    point.x > rect.left + rect.width ||
    point.y < rect.top ||
    point.y > rect.top + rect.height
  ) {
    return false;
  }

  return true;
}

/**
 * @description source 점 배열에서 target 점과 2차원 직선 거리가 가장 가까운
 * 점을 찾는다.(squared euclidean distance)
 *
 * @param sources 점 배열
 * @param target 대상 점
 * @returns 점 배열에서 target 점과 가장 가까운 점을 반환한다.
 */
function findClosestPoint(sources, target) {
  const distances = [];
  let minDistance;

  const distanceFunction = distance;

  sources.forEach(function(source, index) {
    const distance = distanceFunction(source, target);

    distances.push(distance);

    if (index === 0) {
      minDistance = distance;
    } else {
      minDistance = Math.min(distance, minDistance);
    }
  });

  const index = distances.indexOf(minDistance);

  return sources[index];
}

function findClosestPointDistance(sources, target) {
  const distances = [];
  let minDistance;

  const distanceFunction = distance;

  sources.forEach(function(source, index) {
    const distance = distanceFunction(source, target);

    distances.push(distance);

    if (index === 0) {
      minDistance = distance;
    } else {
      minDistance = Math.min(distance, minDistance);
    }
  });

  return minDistance;
}

function getMinDistance(sources, target) {
  const minDistance = findClosestPointDistance(sources, target);

  return minDistance;
}

function copyPoints(points) {
  const page = point.copy(points.page);
  const image = point.copy(points.image);
  const client = point.copy(points.client);
  const canvas = point.copy(points.canvas);

  return {
    page,
    image,
    client,
    canvas
  };
}
const point = {
  subtract,
  copy,
  pageToPoint,
  distance,
  distanceSquared,
  insideRect,
  findClosestPoint,
  getMinDistance
};
export { point, copyPoints };
